<ion-card (click)="linkToDetail(data)">
  <div class="card-img">
    <app-img-format
      [src]="img.url"
      [aspectRatio]="img.aspectRatio"
      [alt]="img.alt"
      [disableLazyLoad]="true"></app-img-format>
  </div>
  <ion-card-header>
    <ion-card-subtitle color="tertiary">
      <ng-container
        *ngIf="!data?.typeSettings?.centerOffer && data?.offerContext?.title">
        {{ data.offerContext.title | titlecase }} &nbsp;|&nbsp;
      </ng-container>
      <ng-container
        *ngIf="showType && data?.postType && !data?.typeSettings?.centerOffer">
        {{ data?.postType | titlecase }} &nbsp;|&nbsp;
      </ng-container>
      <ng-container *ngIf="!hideCategory && !data?.typeSettings?.centerOffer">
        {{ currentCategory?.title | uppercase }} &nbsp;|&nbsp;
      </ng-container>
      <ng-container *ngIf="!startDate && data?.postType !== 'competition'">
        {{ updatedAt | date : 'd MMM y' | uppercase }}
      </ng-container>
      <ng-container
        *ngIf="startDate && !sameDay && data?.postType !== 'competition'">
        {{ startDate | date : 'd MMM' | uppercase }} -
        {{ endDate | date : 'd MMM y' | uppercase }}
      </ng-container>
      <ng-container *ngIf="sameDay && data?.postType !== 'competition'">
        {{ startDate | date : 'd MMM y' | uppercase }}
      </ng-container>
      <ng-container *ngIf="endDate && data?.postType === 'competition'">
        ENDS {{ endDate | date : 'd MMM y' | uppercase }}
      </ng-container>
    </ion-card-subtitle>
    <ion-card-title>{{ data?.title }}</ion-card-title>
  </ion-card-header>
  <ion-card-content *ngIf="data?.typeSettings?.costText && !hidePrice">
    Price &nbsp; {{ data.typeSettings.costText }}
  </ion-card-content>
  <ion-card-content
    *ngIf="
      data?.postType === 'competition' &&
      (data?.excerpt || data?.typeSettings?.excerpt)
    ">
    <span
      *ngIf="
        data?.typeSettings?.excerpt && data?.typeSettings?.isBlog;
        else defaultExcerpt
      ">
      {{ data.typeSettings.excerpt }}
    </span>
    <ng-template #defaultExcerpt>
      {{ data.excerpt }}
    </ng-template>
  </ion-card-content>
</ion-card>
